import { render } from "./RequirementAttachmentMediaDialog.vue?vue&type=template&id=47bb4cdd&scoped=true"
import script from "./RequirementAttachmentMediaDialog.vue?vue&type=script&lang=js"
export * from "./RequirementAttachmentMediaDialog.vue?vue&type=script&lang=js"

import "./RequirementAttachmentMediaDialog.vue?vue&type=style&index=0&id=47bb4cdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bb4cdd"]])

export default __exports__